module.exports = __webpack_public_path__ + "static/img/bladder.png";